import React from "react";
import "./CourseProfile.css";
import test from "../../assets/test.jpg";
import { motion } from "framer-motion";


const CourseProfile = () => {
  return (
    <motion.div className="CourseProfile" whileHover={{scale:1.05}}>
      <div className="card mb-3 card-custom-profile">
        <div className="row g-0">
          <div className="col-md-4">
            <img src={test} className="img-fluid rounded" alt="test" />
          </div>
          <div className="col-md-8">
            <div className="card-body">
              <h5 className="card-title card-title-profile-custom">Course Name</h5>
              <div className="card-content-profile">
                <div className="card-content-profile-left">
                  <div className="card-content-profile-left-row">
                    <h6>Price</h6>
                    <h6 className="price-red">500 LE</h6>
                  </div>
                  <div className="card-content-profile-left-row">
                    <h6>Instructor</h6>
                    <h6>Instructor name</h6>
                  </div>
                </div>
                <div className="card-content-profile-right">
                  <div className="card-content-profile-left-row">
                    <h6>Lessons</h6>
                    <h6>10</h6>
                  </div>
                  <div className="card-content-profile-left-row">
                    <h6>Quizzes</h6>
                    <h6>10</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default CourseProfile;
